import React, { useState,useEffect } from 'react';
import {
  Box, Typography, Grid, Paper, Dialog, DialogContent, IconButton, DialogActions
} from '@mui/material';
import { Carousel } from 'react-bootstrap';
import ReactPlayer from 'react-player/youtube';
import { motion } from 'framer-motion';
import { ArrowBackIos, ArrowForwardIos,Close } from '@mui/icons-material';
import { useMediaQuery, useTheme, DialogTitle,
  Button, } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Stack } from '@mui/material';
import axios from 'axios';
const NewsAndEvents = ({bottomRef }) => {
  const [openImage, setOpenImage] = useState(null);
  const [galleryPage, setGalleryPage] = useState(0);
  const [events, setevents] = useState([]);
  const [news,setnews] =useState([])
  const [youtubeLinks,setyoutubeLinks] =useState([])
  const [galleryImages,setgalleryImages] = useState([])
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const imagesPerPage = isMobile ? 1 : 6;

  const totalPages = Math.ceil(galleryImages.length / imagesPerPage);
  const currentImages = galleryImages.slice(galleryPage * imagesPerPage, (galleryPage + 1) * imagesPerPage);
  const [openCarousel, setOpenCarousel] = useState(false);
  const [selectedEventImages, setSelectedEventImages] = useState([]);
// useEffect(() => {
//   const style = document.createElement("style");
//   style.innerHTML = `
//     .carousel-control-prev-icon,
//     .carousel-control-next-icon {
//       background-color: rgba(0, 0, 0, 0.6) !important;
//       border-radius: 50%;
//       width: 40px;
//       height: 40px;
//       background-size: 100% 100%;
//     }

//     .carousel-control-prev-icon {
//       background-image: url("data:image/svg+xml,%3Csvg fill='white' viewBox='0 0 8 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.5 0l-4 4 4 4v-8z'/%3E%3C/svg%3E") !important;
//     }

//     .carousel-control-next-icon {
//       background-image: url("data:image/svg+xml,%3Csvg fill='white' viewBox='0 0 8 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.5 0l4 4-4 4v-8z'/%3E%3C/svg%3E") !important;
//     }
//   `;
//   document.head.appendChild(style);
//   return () => document.head.removeChild(style); // cleanup
// }, []);

    useEffect(() => {
        // Fetching upcoming events
        fetchevents()
        fetchnews()
        getyoutubelinks()
        getgallarydata()
    }, []);

    const handleKnowMore = async (eventId) => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/events/${eventId}/images`);
        setSelectedEventImages(res.data);
        setOpenCarousel(true);
      } catch (err) {
        console.error('Error loading event images', err);
      }
    };


    const fetchevents= () => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getEventsnews`)
            .then(res => { 
                setevents(res.data);
            })
            .catch(err => console.error('Error fetching events', err))
        };
    const fetchnews= () => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getnews`)
            .then(res => { 
                setnews(res.data);
            })
            .catch(err => console.error('Error fetching events', err))
        };
    const getyoutubelinks= () => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getyoutubelinks`)
            .then(res => { 
                setyoutubeLinks(res.data);
            })
            .catch(err => console.error('Error fetching events', err))
        };
    const getgallarydata= () => {
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getgallarydata`)
          .then(res => { 
            setgalleryImages(res.data);
          })
          .catch(err => console.error('Error fetching events', err))
      };

        
  return (
    <Box sx={{ px: { xs: 2, sm: 4 }, py: 4 }}>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom align="center" color="primary">
          🎉 Highlights
        </Typography>
      </motion.div>

      <Box sx={{ mb: 6 }}>
        {/* Flexbox Layout for Video Section on Desktop and Mobile */}
        <Typography variant="h6" fontWeight="bold" mb={2}>📅 Upcoming Events & 🖼️ Gallery</Typography>
        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 4,
          alignItems: 'flex-start'
        }}>
          {/* Left: Upcoming Events */}
          <Paper elevation={6} sx={{
            flex: 1,
            width: '100%',
            p: 2,
            borderRadius: 3,
          }}>
            <Box sx={{ flex: 1, maxHeight: 400, overflowY: 'auto' }}>
              <Grid container spacing={2} direction="column">
                {events.map((item, idx) => (
                  <Grid item xs={12} key={`event-${idx}`} flexDirection="column">
                    {/* <Paper elevation={3} sx={{ p: 2 }}>
                      <Typography variant="subtitle2" color="text.secondary">{item.date}</Typography>
                      <Typography fontWeight="bold" mt={1}>{item.title}</Typography>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ mt: 1 }}
                        onClick={() => handleKnowMore(item.id)}
                      >
                        Know More
                      </Button>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <LocationOnIcon fontSize="small" color="action" />
                        <Typography variant="body2">{item.description}</Typography>
                      </Stack>
                      {item.link && (
                        <Typography variant="body2" mt={1}>
                          <a
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#1976d2', textDecoration: 'underline' }}
                          >
                            Click here to Register 
                          </a>
                        </Typography>
                      )}
                    </Paper> */}
                    <Paper elevation={3} sx={{ p: 2, display: 'flex', flexDirection: 'column', minHeight: 200 }}>
                        <Typography variant="subtitle2" color="text.secondary">{item.date}</Typography>
                        <Typography fontWeight="bold" mt={1}>{item.title}</Typography>

                        <Stack direction="row" alignItems="center" spacing={1} mt={1}>
                          <LocationOnIcon fontSize="small" color="action" />
                          <Typography variant="body2">{item.description}</Typography>
                        </Stack>

                        <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                          <Box flexGrow={1}>
                            {item.link ? (
                              <Typography variant="body2">
                                <a
                                  href={item.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: '#1976d2', textDecoration: 'underline' }}
                                >
                                  Click here to Register
                                </a>
                              </Typography>
                            ) : null}
                          </Box>

                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => handleKnowMore(item.id)}
                          >
                            Know More
                          </Button>
                        </Box>
                      </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Paper>

          {/* Gallery Section */}
          <Box sx={{ flex: 1 }}>
            <Grid container spacing={2}>
              {currentImages.map((imgUrl, idx) => (
                <Grid item xs={4} key={idx}>
                  <motion.div whileHover={{ scale: 1.05 }} transition={{ type: 'spring', stiffness: 100 }}>
                  <Box
                  sx={{
                     position: 'relative',
                    height: 150,
                    borderRadius: 6,
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#f0f0f0',
                    flexDirection: 'column',
                    cursor: 'pointer',
                  }}
                  onClick={() => setOpenImage(imgUrl.image)}
                >
                  <img
                    src={imgUrl.image}
                    alt={`Gallery ${idx}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      cursor: 'pointer',

                    }}
                  />
                  {/* Title Overlay */}
                  <Box
                  sx={{
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    background: 'rgba(0, 0, 0, 0.6)',
                    color: '#fff',
                    textAlign: 'center',
                    py: 0.5,
                    px: 1,
                    fontSize: '0.75rem',
                    fontWeight: 500,
                  }}
                  >
                  {imgUrl.title || ''}
                  </Box>
                </Box>

                  </motion.div>
                </Grid>
              ))}
            </Grid>

            {/* Navigation for Gallery */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <IconButton
                onClick={() => setGalleryPage((prev) => Math.max(prev - 1, 0))}
                disabled={galleryPage === 0}
              >
                <ArrowBackIos />
              </IconButton>
              <Typography sx={{ mx: 2, mt: 1 }}>{galleryPage + 1} / {totalPages}</Typography>
              <IconButton
                onClick={() => setGalleryPage((prev) => Math.min(prev + 1, totalPages - 1))}
                disabled={galleryPage === totalPages - 1}
              >
                <ArrowForwardIos />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* News & Gallery */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h5" fontWeight="bold" mb={2}>📰 News & 🎬 Featured Videos</Typography>
        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 4,
          alignItems: 'flex-start',
        }}>
          {/* News Section */}
          <Paper elevation={6} sx={{
            flex: 1,
            width: '100%',
            p: 2,
            borderRadius: 3,
          }}>
            <Box sx={{ flex: 1, maxHeight: 400, overflowY: 'auto' }}>
              <Grid container spacing={2} direction="column">
                {news.map((item, idx) => (
                  <Grid item xs={12} key={`news-${idx}`}>
                    <Paper elevation={3} sx={{ p: 2 }}>
                      <Typography variant="caption" color="text.secondary">{item.createdDate}</Typography>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {item.headline}
                      </Typography>
                      <Typography variant="body2">{item.summary}</Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Paper>

          {/* Featured Videos */}
          <Box ref={bottomRef} sx={{ flex: 1 }}>
          
            <Carousel interval={6000} pause="hover">
              {youtubeLinks.map((url, idx) => (
                <Carousel.Item key={idx}>
                  <ReactPlayer url={url.url} width="100%" height="300px" controls />
                </Carousel.Item>
              ))}
            </Carousel>
          </Box>
        </Box>
      </Box>

      {/* Image Dialog */}
      <Dialog open={Boolean(openImage)} onClose={() => setOpenImage(null)} maxWidth="md">
        <DialogActions>
          <IconButton onClick={() => setOpenImage(null)} sx={{ ml: 'auto' }}>
            <Close />
          </IconButton>
        </DialogActions>
        <DialogContent>
          <img
            src={openImage}
            alt="Preview"
            style={{ width: '100%', maxHeight: '80vh', objectFit: 'contain' }}
          />
        </DialogContent>
      </Dialog>
      
      {/* imagecarosal */}
      <Dialog open={openCarousel} onClose={() => setOpenCarousel(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          Event Photos
          <IconButton
            onClick={() => setOpenCarousel(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent >
          {selectedEventImages.length > 0 ? (
            <Carousel style={{backgroundColor:'black'}}>
              {selectedEventImages.map((img, idx) => (
                <Carousel.Item key={idx}>
                  <img
                    src={`${process.env.REACT_APP_API_BASE_URL}/api/admin/events/images/${img.id}`}
                    alt={`event-img-${img.id}`}
                    style={{
                          width: '100%',
                          height: '70vh',
                          objectFit: 'contain',
                          borderRadius: 6
                        }}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            <Typography>No images available for this event.</Typography>
          )}
        </DialogContent>
      </Dialog>

    </Box>
  );
};

export default NewsAndEvents;
